import { NavigatorCreateProgram, NavigatorProgram } from '@/models/independent-study/navigator-program';
import { sessionService } from '@/providers/services/auth/session';

class IndependentStudySerializer {
    public static instance = new IndependentStudySerializer();
    public get session() {
        return sessionService.getSession();
    }
    public selializePrograms(payload: any) {

        const serializedPrograms: NavigatorProgram[] = [];
        if (payload) {
            const programList = payload.program || [];
            programList.map((program: any) => {
                const audience = program.audience && program.audience.replace(/[{"}]+/g, '');
                const audienceRes = audience.charAt(0).toUpperCase() + audience.slice(1);
                const serializedProgram: NavigatorProgram = {
                    id: program.id,
                    title: program.title,
                    description: program.description,
                    thumbnail: program.images && program.images.thumbnail || null,
                    filterItems: [{
                            audience: audienceRes,
                        },
                        {
                            grade: program.grade_current_details.grade,
                        }],
                    productId: program.product_id,
                    referenceId: program.reference_id,
                    courseId: program.course_id,
                    shortDescription: program.short_description,
                    category: program.additional_info.category,
                    subject: program.additional_info.subject,
                    framework: program.framework,
                    country: program.locations[0].location_code,
                    price: program.locations[0].price,
                    subscription: program.subscription_validity_in_days,
                    currency: program.locations[0].location_code,
                    audience: program.audience,
                    markerId: program.marker_id,
                    gradeLower: program.grade_lower_bound,
                    gradeUpper: program.grade_upper_bound,
                    gradeCurrent: program.grade_current,
                    diagnosticApplicable: program.is_diagnostic_applicable,
                    programType: program.is_paid_program ? 'Paid' : 'Free',
                    courses: undefined,
                    markers: undefined,
                };
                serializedPrograms.push(serializedProgram);
            });
            const totalCount = payload.totalCount;
            return { totalCount, serializedPrograms };
        }
    }
    public normalizeCreateProgram(payload: any) {
        const tenantId = this.session && this.session.tenant!.tenant_id;
        const userId = this.session && this.session.user_id;
        const validity = typeof payload.subscriptionValidity === 'string' && payload.subscriptionValidity.match(/\d+/);
        const framework = payload.framework.split('.')[0];
        if (payload) {
            const serializedCreateProgram: NavigatorCreateProgram = {
                title: payload.courseTitle,
                description: payload.courseDescription,
                course_id: payload.courses ? payload.courses : null,
                marker_id: payload.markers ? payload.markers : null,
                tenant: tenantId,
                grade_lower_bound: payload.lowerGrade,
                grade_upper_bound: payload.grade,
                grade_current: payload.grade,
                framework,
                instructor_id: userId,
                creator_id: userId,
                modifier_id: userId,
                additional_info: {
                    subject: payload.subject,
                    category: payload.category,
                },
                audience: payload.audience,
                is_diagnostic_applicable: payload.isDiagnosticApplicable,
                images: payload.images,
                locations: [
                    {
                        price: payload.price,
                        currency: payload.country,
                        location_code: payload.country,
                    },
                ],
                short_description: payload.courseShortDescription,
                is_paid_program: payload.programType === 'paid' ? true : false,
                subscription_validity_in_days: validity ? parseInt(validity[0], 10) : null,
                product_id: parseInt(payload.product, 10),
                reference_id: payload.referenceId,
            };
            return serializedCreateProgram;
        }
    }

}

export const independentStudySerializer = IndependentStudySerializer.instance;
